import type { ConsultationPaymentStatus } from './useConsult';

/**
 * Hook to derive Shopify payment state using only the relevant state.
 * @param paymentStatus.paymentStatus
 * @param paymentStatus - The current payment status of the consultation
 * @param paidDate - The date the consultation was paid
 * @param invoiceCode - The code of the xero invoice for the consultation indicating a consultation has been invoiced
 * @param paymentStatus.paidDate
 * @param paymentStatus.invoiceCode
 * @returns The derived payment state
 */
export function usePaymentStatus({
  paymentStatus,
  paidDate,
  invoiceCode,
}: {
  paymentStatus?: ConsultationPaymentStatus;
  paidDate?: string | null;
  invoiceCode?: string | null;
}) {
  if (paymentStatus === 'PAID' || paymentStatus === 'REFUNDED' || paidDate) {
    return 'PAID';
  }
  if (paymentStatus === 'INVOICED' || invoiceCode) {
    return 'IN_PROGRESS';
  }
  return 'NOT_PAID';
}
